import { useState, useEffect, useCallback } from 'react';
import SignalApiService from '../services/signalApi';

const REFRESH_INTERVAL = 60000; // 60 seconds

export const useSignal = () => {
  const [signal, setSignal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);

  const fetchSignal = useCallback(async () => {
    try {
      const result = await SignalApiService.getCurrentSignal();
      if (result.success) {
        setSignal(result.data);
        setError(null);
        setLastUpdated(new Date());
      } else {
        setError(result.error || 'Failed to fetch signal');
      }
    } catch (err) {
      setError(err.message || 'Failed to fetch signal');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSignal();

    const interval = setInterval(fetchSignal, REFRESH_INTERVAL);

    return () => clearInterval(interval);
  }, [fetchSignal]);

  const refetch = useCallback(() => {
    setLoading(true);
    fetchSignal();
  }, [fetchSignal]);

  return {
    signal,
    loading,
    error,
    lastUpdated,
    refetch,
  };
};

export default useSignal;
